import { ReportOrdersTotal } from "../../../../../core/models/picking/report-orders-total.model";

export const pickingReport = {
  searchText: '',
  addText: '',
  expandable: false,
  paginator: true,
  disabled: false,
  partialField: '',
  export: true,
  exportAllData: true,
  exportFile: 'reporte_de_pedidos.xlsx',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  columns: [
    {
      title: 'SKU',
      name: 'sku',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.sku,
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      value: (x: ReportOrdersTotal) => (x.description ? x.description.replace('�', '') : ''),
    },
    {
      title: 'Marca',
      name: 'tradeMark',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.tradeMark,
    },
    {
      title: 'Estado',
      name: 'stateOrderName',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.stateOrderName,
    },
    {
      title: 'Número de nota de venta',
      name: 'orderNumber',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.orderNumber,
    },
    {
      title: 'LPN',
      name: 'containerSerialNumber',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.containerSerialNumber,
    },
    {
      title: 'Cantidad solicitada',
      name: 'sAmountRequested',
      type: 'string',
      value: (x: ReportOrdersTotal) => Number(x.sAmountRequested)
    },
    {
      title: 'Cantidad atendida',
      name: 'sAmountAttended',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.sAmountAttended,
    },
    {
      title: 'Cantidad consolidada',
      name: 'sAmountConsolidated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.sAmountConsolidated,
    },
    {
      title: 'Cantidad cancelada',
      name: 'sAmountCancelled',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.sAmountCancelled,
    },
    {
      title: 'División',
      name: 'division',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.division,
    },
    {
      title: 'Área',
      name: 'area',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.area,
    },
    {
      title: 'Departamento',
      name: 'department',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.department,
    },
    {
      title: 'Entidad de picking',
      name: 'entityId',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.entityId,
    },
    {
      title: 'Fecha y hora de creación',
      name: 'dateCreated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dateCreated,
    },
    {
      title: 'Fecha y hora de creación de despacho',
      name: 'dispatchCreatedAt',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dispatchCreatedAt,
    },
    {
      title: 'Ubicación',
      name: 'location',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.location,
    },
    {
      title: 'Fecha de despacho',
      name: 'dateDispatch',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dateDispatch,
    },
    {
      title: 'Fecha y hora de inico de picking',
      name: 'lotDateCreated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.lotDateCreated,
    },
    {
      title: 'Fecha y hora de fin de picking',
      name: 'lotFinishedAt',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.lotFinishedAt,
    },
    {
      title: 'Fecha y hora de inicio de packing',
      name: 'dateConsolidatedInitial',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dateConsolidatedInitial,
    },
    {
      title: 'Fecha y hora de creación LPN',
      name: 'containerDateCreated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.containerDateCreated,
    },
    {
      title: 'Fecha y hora de ubicación LPN/Jaba',
      name: 'labelDateCreated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.labelDateCreated,
    },
    {
      title: 'Fecha y hora de consolidación',
      name: 'dateConsolidated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dateConsolidated,
    },
    {
      title: 'Fecha y hora de Facturación',
      name: 'confirmationDate',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.confirmationDate,
    },
    {
      title: 'Tipo de despacho',
      name: 'methodDelivery',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.methodDelivery,
    },
    {
      title: 'Estado de despacho',
      name: 'stateOrderDispatchName',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.stateOrderDispatchName,
    },
    {
      title: 'Usuario picking',
      name: 'userPicking',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.userPicking,
    },
    {
      title: 'Usuario primer picking',
      name: 'firstPicker',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.firstPicker,
    },
    {
      title: 'Usuario final picking',
      name: 'finalPicker',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.finalPicker,
    },
    {
      title: 'Usuario último picking',
      name: 'userLastPicking',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.userLastPicking,
    },
    {
      title: 'Usuario consolidación',
      name: 'userConsolidated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.userConsolidated,
    },
    {
      title: 'Usuario primera ubicación',
      name: 'pickerLocation',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.pickerLocation,
    },
    {
      title: 'Usuario última ubicación',
      name: 'lastLocationPicker',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.lastLocationPicker,
    },
    {
      title: 'Usuario(s) pre cancelación',
      name: 'preCancellationUser',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.precancelledUsername,
    },
    {
      title: 'Usuario(s) cancelación',
      name: 'cancellationUser',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.cancelledUsername,
    },
    {
      title: 'Fecha y hora de impresión de etiqueta final',
      name: 'lastUpdated',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.lastUpdated,
    },
    {
      title: 'Fecha de confirmación del cliente',
      name: 'confirmationDate1',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.confirmationDate,
    },
    {
      title: 'Fecha y hora de cancelación',
      name: 'canceledAt',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.canceledAt,
    },
    {
      title: 'Destino final',
      name: 'destinationRoute',
      type: 'string',
      value: (x: ReportOrdersTotal) => {
        if (x.destinationRoute) {
          const entitiesRoutes = x.destinationRoute.split('-');
          return entitiesRoutes[entitiesRoutes.length - 1];
        }
        return '';
      },
    },
    {
      title: 'Motivo de faltante inicial',
      name: 'incompleteConcat',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.incompleteConcat,
    },
    {
      title: 'Motivo de faltante final',
      name: 'incompletePrecancel',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.incompletePrecancel,
    },
    {
      title: 'Ecommerce ID',
      name: 'ecommerceId',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.ecommerceId,
    },
    {
      title: 'Picking cruzado',
      name: 'pickingCrossed',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.pickingCrossed,
    },
    {
      title: 'Sucursal cruzada / Estado de despacho',
      name: 'entityCrossed',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.entityCrossed,
    },
    {
      title: 'Fecha y hora de inicio de reingreso',
      name: 'reEntryStartDate',
      type: 'string',
      checkAll: false,
      editable: false,
      value: (x: ReportOrdersTotal) => x.reEntryStartDate,
    },
    {
      title: 'Fecha y hora de fin de reingreso',
      name: 'endDateOfReEntry',
      type: 'string',
      checkAll: false,
      editable: false,
      value: (x: ReportOrdersTotal) => x.endDateOfReEntry,
    },
    {
      title: 'Estado de pago(Respuesta del EMAP)',
      name: 'pendingPayment',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.pendingPayment,
    },
    {
      title: 'Tipo de despacho',
      name: 'dispatchTypeCode',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.dispatchTypeCode,
    },
    {
      title: 'Medio de pago',
      name: 'paymentMethodName',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.paymentMethodName,
    }
    , {
      title: 'Fecha máxima de carga',
      name: 'datePicking',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.pickingDate,
    },
    {
      title: 'Número de despacho',
      name: 'serialNumber',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.serialNumber,
    },
    {
      title: 'Fecha de despacho original',
      name: 'deliveryDate',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.deliveryDate,
    },
    {
      title: 'Canal de venta',
      name: 'saleChannel',
      type: 'string',
      value: (x: ReportOrdersTotal) => x.saleChannel,
    },
  ],
};
